import React from 'react';
import styled from 'styled-components';

//:(
const SECONDARY_BORDER = '#b3b3b3';
const SECONDARY_TEXT = '#595959';

const BASE_BLUE = '#086afd';
const DARK_BLUE = '#0037ca';
const LIGHT_BLUE = '#308af9';
const WHITE = '#fff';
const LIGHT_GRAY = '#d9d9d9';
const DARKER_GRAY = '#cdcdcd';
const DARK_GRAY = '#999';

const backgroundColor = ({ primary, disabled }) =>
    disabled ? LIGHT_GRAY : primary ? BASE_BLUE : WHITE;

const border = ({ primary, disabled }) =>
    disabled ? `1px solid ${DARKER_GRAY}` : primary ? 'none' : `1px solid ${SECONDARY_BORDER}`;

const color = ({ primary, disabled }) => (disabled ? DARK_GRAY : primary ? WHITE : SECONDARY_TEXT);

//Exported as an escape hatch, DO NOT IMPORT UNLESS YOU HAVE GREAT REASON TO
export const StyledButton = styled.button`
    background-color: ${backgroundColor};
    border: ${border};
    color: ${color};
    text-transform: none;
    font-size: 1em;
    font-weight: normal;
    border-radius: 4px;
    max-height: 2em;
    padding: .25em 1em;
    transition: background-color ease-in 100ms, border-color ease-in 100ms;

    ${({ disabled }) => (disabled ? `` : `cursor: pointer;`)}

    ${({ primary, disabled }) =>
        primary &&
        !disabled &&
        `
        &:hover, &:focus {
            background-color: ${LIGHT_BLUE};
        }
        &:active {
            background-color: ${DARK_BLUE};
        }
    `} ${({ secondary, disabled }) =>
        secondary &&
        !disabled &&
        `
        outline: none;
        &:hover {
            color: ${LIGHT_BLUE};
            border-color: ${LIGHT_BLUE};
        }
        &:active {
            color: ${DARK_BLUE};
            border-color: ${DARK_BLUE};
        }
    `};
`;

const Button = ({ type = 'button', ...props }) => <StyledButton {...props} type={type} />;

export default Button;
